import { Badge } from '@sravni/react-design-system/lib/Badge';
import { Text, Heading } from '@sravni/react-design-system/lib/Typography';

import type { Winner } from '@src/@types/ozonPrizeWinners';
import { OptimizedPicture } from '@src/components/ui/OptimizedPicture';
import { UNBREAKABLE_SEPARATOR } from '@src/constants/unbreakableSeparator';
import { getHiddenPhoneNumber } from 'entities/Banner/ui/OctoberPrizeDraw/utils';

import { OZON_PRIZE_TEXT } from '../../../constants';

import styles from './styles.module.scss';

export const SecondaryWinnersItem = ({ phoneNumber, avatarSrc, amount, fio }: Winner) => {
  const hiddenPhoneNumber = getHiddenPhoneNumber(phoneNumber);

  return (
    <div className={styles.container}>
      <OptimizedPicture imgClassName={styles.avatar} img={avatarSrc} alt="avatar" />

      <div>
        <Heading className="h-color-B300" level={5}>
          {hiddenPhoneNumber}
        </Heading>
        <Text size={14} className="h-text-center">
          {fio ?? UNBREAKABLE_SEPARATOR}
        </Text>
      </div>

      <div className={styles.textContent}>
        <Text size={10} className={styles.text}>
          {OZON_PRIZE_TEXT}
        </Text>
        <Badge color="violet" variant="primary" text={amount} />
      </div>
    </div>
  );
};
